module.exports = __webpack_public_path__ + "img/icon-logo-placeholder.797fd871.svg";